var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9151_65)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 87.5,
    cy: 87.5,
    r: 87.5,
    fill: "#242426"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.972 56.644C110.83 48.495 100.006 44.0036 88.4746 44C64.7128 44 45.3734 63.3358 45.3625 87.1085C45.3589 94.7065 47.3454 102.123 51.119 108.663L45 131L67.852 125.004C74.1486 128.441 81.2391 130.25 88.4529 130.253H88.471C112.229 130.253 131.572 110.914 131.583 87.1411C131.59 75.6245 127.11 64.7894 118.972 56.644ZM88.4746 122.971H88.4601C82.0294 122.971 75.7255 121.242 70.2227 117.975L68.9141 117.2L55.353 120.756L58.9744 107.532L58.1225 106.176C54.5338 100.47 52.6415 93.8764 52.6451 87.1085C52.6524 67.3523 68.7293 51.279 88.4928 51.279C98.0628 51.279 107.06 55.0128 113.824 61.7843C120.589 68.5594 124.311 77.5602 124.308 87.1339C124.297 106.897 108.224 122.971 88.4746 122.971ZM108.129 96.1348C107.053 95.5946 101.757 92.9883 100.767 92.6294C99.781 92.2705 99.0633 92.0892 98.3419 93.1659C97.6205 94.2425 95.5615 96.6712 94.9308 97.3926C94.3036 98.1104 93.6729 98.201 92.5963 97.6609C91.5196 97.1208 88.0469 95.9861 83.9325 92.314C80.7316 89.4575 78.5675 85.9304 77.9404 84.8501C77.3133 83.7699 77.8751 83.1899 78.4116 82.6534C78.8974 82.1712 79.4883 81.3955 80.0284 80.7648C80.5721 80.1413 80.7498 79.6917 81.1123 78.9704C81.4711 78.2526 81.2935 77.6219 81.0216 77.0818C80.7498 76.5452 78.5965 71.2419 77.7011 69.085C76.8275 66.9825 75.9394 67.2689 75.276 67.2362C74.6489 67.2036 73.9311 67.2 73.2098 67.2C72.492 67.2 71.3248 67.4683 70.3388 68.5485C69.3528 69.6287 66.5688 72.2351 66.5688 77.5349C66.5688 82.8383 70.4294 87.9604 70.9659 88.6781C71.5024 89.3959 78.5602 100.278 89.3664 104.944C91.9365 106.053 93.9448 106.716 95.5071 107.213C98.0881 108.032 100.437 107.916 102.293 107.64C104.363 107.332 108.666 105.034 109.565 102.518C110.464 100.003 110.464 97.8421 110.192 97.3962C109.924 96.9431 109.206 96.6749 108.129 96.1348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9151_65"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.05de4be2ccf6da42dcc775c8b01e08f3.svg";
export { ForwardRef as ReactComponent };